const moduleName = 'ssr';

export const ssrDataSelector = state => state[moduleName];
